export const LOCAL_STORE_ACCOUNT = 'organization';
export const LOCAL_STORE_SEASON= 'season';
